(function ($) {

RVwys.plugin['MyWidget'] = true;



 $(document).bind('editorReady',function(){
	 
 });
 
 $(document).bind('editorDesign',function(event){
	 
 });
 
 $(document).bind('editorSource',function(event){
	 
 });
 
 $(document).bind('editorClose',function() {
	 
 });
 
 RVwys.designViewAddEvent('drop',function(event) {
	 event.originalEvent.preventDefault();
	 var data = event.originalEvent.dataTransfer.getData("text");
	 $(event.target).append(data);
	// alert(data)
 });
 
 //widget

 RVwys.widget.mywidget = {};

 //end widget for jotform

 RVwys.widget.mywidget.sortDate = function(othis){

	 var $listWidget = $('#listWidget');
	 orderBy = $(othis).attr('orderBy')
	 if (orderBy == 'asc') {
		 $listWidget.find('div[time]').sort(function(a,b){
			 return +a.getAttribute('time') - +b.getAttribute('time');
		 }).appendTo( $listWidget );
		 $(othis).attr('orderBy','desc');
		 //$('#arrowWidgetDate').text('down')
	 } else {
		 $listWidget.find('div[time]').sort(function(a,b){
			 return +b.getAttribute('time') - +a.getAttribute('time');
		 }).appendTo( $listWidget );
		 $(othis).attr('orderBy','asc');
		// $('#arrowWidgetDate').text('up')
	 }
	 $('#arrowWidgetDate').removeClass('arrow-down');
	 $('#arrowWidgetDate').addClass('arrow-up');

 }
 RVwys.widget.mywidget.sortType = function(othis){
	 var $listWidget = $('#listWidget');
	 orderBy = $(othis).attr('orderBy')
	 if (orderBy == 'asc') {
		 $listWidget.find('div[sortType]').sort(function(a,b){
			 return +a.getAttribute('sortType') - +b.getAttribute('sortType');
		 }).appendTo( $listWidget );
		 $(othis).attr('orderBy','desc');
		 //$('#arrowWidgetType').text('down')
	 } else {
		 $listWidget.find('div[sortType]').sort(function(a,b){
			 return +b.getAttribute('sortType') - +a.getAttribute('sortType');
		 }).appendTo( $listWidget );
		 $(othis).attr('orderBy','asc');
		 //$('#arrowWidgetType').text('up');
	 }
	 $('#arrowWidgetType').removeClass('arrow-down');
	 $('#arrowWidgetType').addClass('arrow-up');
 }
 
 RVwys.widget.mywidget.list = function(){
		var frmParam = '&rvsMgr=RVwysiwygUikit&rvsAct=listWidget'+ "&project_id=" + parent.project_id;
		$('#listWidget').html('<img src="' + parent.wex.url.rvsThemImage + 'loading02.gif"width="29" height="27" border="0" align="abmiddle" /><span style="font-size:13px;">loading...</span>');
		parent.jQuery.sitebuilder.Ajax.connect(frmParam, {
	        url : parent.RVS_AJAX_INDEX.replace('rvwysiwyguikit','sitebuilder')
	        ,waitDialog: function(ev) {}
	        ,callback: {
	                doError: function(data) {
	                    defXHR = parent.jQuery.sitebuilder.string.decode(data.responseText);
	                    a = parent.jQuery('<div/>').buildDialogError(defXHR);
	                    a.dialog('open');
	         	},
					doSuccess: function(data) {
						if (data) {
							$('#listWidget').html('');
							if (data.success) {
								var widgetFetch = '';
								$.each(data.listForm,function(k, v){
									RVwys.widget.mywidget[v.widget_type].iconView(v);
								})
							}
						}
					}                                                        
				}
			});
		
 }

 RVwys.widget.mywidget.sectionReceive = function(oThis,e,ui) {
	    widgetApp = ui.item.attr('widgetType');
	    if (RVwys.widget.mywidget[widgetApp].sectionReceive) {
	    	RVwys.widget.mywidget[widgetApp].sectionReceive(oThis,e,ui);	    	
	    }
 }
 
 RVwys.elementSortable = function(){


 	$('.RVWYSIWYGAREA').find('*').not('img,br,hr').disableSelection().sortable({
		  handle:".imgFacebookLike",
		 appendTo: 'body',
		 opacity: '.5',
		//connectWith:['.editable_area','.RVWYSIWYGAREA *'],
		 connectWith:['.RVWYSIWYGAREA *'],
		start:function(e, ui){
			//alert('s')
				$('.RVWYSIWYGAREA').find('*').not('img,br,hr').disableSelection()//.sortable('enable')
		},
		stop:function(e, ui){
	
				$('.RVWYSIWYGAREA').find('*').not('img,br,hr').enableSelection().sortable('destroy')
		},
		 helper: function (e, li) {
			 return $('<div class ="rvSWDhelper" style="width:'+li.width()+'px;height:'+li.height()+'px;border:solid 3px #fcfcfc;"></div>');
		 },
        placeholder: {
            element: function(e, li) {
            	var groupPHB = $(e).find('img').attr('group');
            	var phd =  $($('.tpl-block-placeholder').html().replace(/ui-placeholder-block/i,groupPHB));
            	return phd[0];
            },
            update: function(e, li) {
                return;
            },
        },
        receive: function (e, ui) {

       	 if ($(ui.item).attr('widget')) {

       		 console.log('element receive'+$(ui.item).attr('widget'));
       		 if (RVwys.widget[$(ui.item).attr('widget')].elementReceive) {
       			 console.log('call back element receive');
       			 RVwys.widget[$(ui.item).attr('widget')].elementReceive(this,e,ui);
       		 } else {
       			 console.log('none call back element receive');
       		 }
       		 //RVwys.imageEditorToolResetPos();

       	 } else {
       		 ui.sender.data('copied', true);
       		 var bms = $('#blockMainSetting');
       		// ui.item.replaceWith(ui.item.attr('data'));
       		 $(this).parent().find('.dropHere').remove();
       		 
       	 }
   		 setTimeout(function(){
    			//$('.RVWYSIWYGAREA').find('*').sortable('destroy');
    			setTimeout(function(){
    				RVwys.elementSortable();
    			},500)
    		 },500)
       	 //RVwys.imageEditorToolResetPos();
        }
  
	});
 }
var oListWidget;
$(document).bind('designReady',function(e){
	oListWidget = $('#listWidget').disableSelection().sortable({
		 connectWith:".editable_area",
		 opacity: '.5',
		 appendTo: 'body',
		 sort: function( e, ui ) {
	        	RVwys.hidemgActive();
	     },
		 placeholder: {
	                element: function(e, li) {
	                	return $($('.tpl-placeholder').html())[0];
	                },
	                update: function(e, li) {
	                    return;
	                }
	     },
		helper: function (e, ui) {
				this.copyHelper = ui.clone().insertAfter(ui);
				$(this).data('copied', false);
				return $('<div class ="rvSWDhelper" style="width:200px;border:solid 3px #fcfcfc;"></div>');
		},
		stop: function (e, ui) {
			 var $uiItem = $(ui.item);
             if ($uiItem.parent().is('#listWidget')) $uiItem.remove();
             $('.layoutResize').remove();
		 }
	});

    $('.WidgetSetting').unbind('click').click(function() {
		if ($(this).parent().find('.menuLeftOver').length != 1) {
			$(this).parent().find('div').eq(0).removeClass('menuLeftOut').addClass('menuLeftOver');
		}
		
		$('.menuLeftOver').removeClass('menuLeftOver').addClass('menuLeftOut');

		//RVwys.elementSortable();
    	
    });

	
	
});


 
 $(document).bind('widgetClose',function(){

 });
 
 
})(jQuery);